import {
    faChevronCircleLeft,
    faCloud,
    faHistory,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import {
    IdevOpsCard,
    IGetBugCardDevOpsByIDCaso,
} from "../../../../../Interfaces/DevOps/DevOps";
import HistoricoCard from "../HistoricoCard";

interface ICustomHeaderCard {
    validarEdicao: IdevOpsCard | undefined;
    setShow: Dispatch<SetStateAction<boolean>>;
    getBugCardDevOpsByIDCaso: IGetBugCardDevOpsByIDCaso | undefined;
    setModal: (value: SetStateAction<IComponentModal | undefined>) => void;
}

export default function CustomHeaderCard(props: ICustomHeaderCard) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    return (
        <div className="w-100">
            <div className="w-100 d-flex justify-content-between align-itens-center modal-title">
                <div className="d-flex justify-content-center align-itens-center mt-2 h3">
                    <FontAwesomeIcon
                        icon={faCloud}
                        className="mr-2 d-flex justify-content-center align-itens-center"
                    />
                    <span className="card-label font-weight-bolder">
                        {Number(localStorage.getItem("vincularCards")) === 0 ||
                        Number(localStorage.getItem("vincularCards")) === 1
                            ? "Vincular"
                            : props.validarEdicao
                            ? "Editar Card"
                            : "Cadastrar Card"}
                    </span>
                </div>
                <div className="d-flex align-itens-end">
                    {props.validarEdicao
                        ? Number(localStorage.getItem("vincularCards")) ===
                              2 && (
                              <OverlayTrigger
                                  overlay={
                                      <Tooltip id="ver-atendimento-tooltip">
                                          Visualizar Histórico
                                      </Tooltip>
                                  }
                              >
                                  <FontAwesomeIcon
                                      icon={faHistory}
                                      size="2x"
                                      type="button"
                                      onClick={() => {
                                          setShow(true);
                                          setModal({
                                              Component: () =>
                                                  HistoricoCard({
                                                      getBugCardDevOpsByIDCaso:
                                                          props.getBugCardDevOpsByIDCaso,
                                                  }),
                                              headerComponent: "Histórico",
                                              IconHeader: faHistory,
                                              size: "lg",
                                          });
                                      }}
                                  />
                              </OverlayTrigger>
                          )
                        : Number(localStorage.getItem("vincularCards")) ===
                              2 && (
                              <>
                                  <button
                                      className="btn btn-outline-dark border-0"
                                      onClick={() => {
                                          props.setShow(false);
                                          localStorage.setItem(
                                              "vincularCards",
                                              String(0)
                                          );
                                      }}
                                  >
                                      <FontAwesomeIcon
                                          icon={faChevronCircleLeft}
                                          size="1x"
                                          type="button"
                                          className="mr-1"
                                      />
                                      Voltar
                                  </button>
                              </>
                          )}
                </div>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
